import { LoginWrapper } from './login.styles';
import useMsal from '../../auth/useMsal';
import useExternalMsal from '../../auth/useExternalMsal';

// Odfjell users and external fleet users sign in with the internal Azure AD
// tenant. External managers use the Entra External ID (CIAM) hosted flow.
const Login = () => {
    const { loginAzAd } = useMsal();
    const { loginExternal } = useExternalMsal();

    const handleExternalLogin = () => {
        loginExternal();
    };

    return (
        <LoginWrapper>
            <h1>Welcome</h1>
            <div>
                <p>Please login or sign up for access to OrcaWeb</p>
                <div className="contact-details">
                    For questions, please contact
                    <a href="mailto:fleetperformance@odfjell.com"> fleetperformance@odfjell.com</a>
                </div>
                <div className="login-option">
                    <button type="button" onClick={loginAzAd} aria-describedby="odfjell-user-description">
                        Odfjell User
                    </button>
                    <span id="odfjell-user-description" className="option-description">
                        On-shore and vessel users
                    </span>
                </div>
                <div className="login-option">
                    <button type="button" onClick={loginAzAd} aria-describedby="external-fleet-user-description">
                        External Fleet User
                    </button>
                    <span id="external-fleet-user-description" className="option-description">
                        Vessel users
                    </span>
                </div>
                <hr className="login-option-divider" />
                <div className="login-option">
                    <button type="button" onClick={handleExternalLogin}>
                        External Manager
                    </button>
                </div>
            </div>
        </LoginWrapper>
    );
};

export default Login;
